export default "__VITE_ASSET__DsjtOI11__"